import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'


export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectStateResponsibleList = state => {
    return selectOwnState(state).stateResponsibleList
}

export const selectStateResponsibleById = (state, stateResponsibleId) => {
    const stateResponsibleList = selectStateResponsibleList(state)
    for (let index = 0; index < stateResponsibleList.length; index++) {
        const stateResponsible = stateResponsibleList[index]
        if (stateResponsible.id === stateResponsibleId) {
            return stateResponsible
        }
    }
    return null
}



// WEBPACK FOOTER //
// ./src/modules/process/state/state-responsible/selector.js